import React from "react";
import avatar from "../assets/mira-avatar.webp";

// Identifiant de l'assistant dans les données (auteur d'un message, d'un geste) : le même que côté serveur
// (core.get_assistant). Le nom affiché, lui, vient toujours du serveur (« mira.ia »).
export const ASSISTANT_ID = "assistant";

// Avatar de l'assistant (Mira, qui signe « mira.ia ») : l'avatar complet de la planche de Mélilia, sur fond transparent,
// partout où il apparaît (décision du 02/10). C'est une image : ses couleurs restent dans le fichier, la palette ne bouge
// pas. Décoratif : le nom de l'assistant est toujours écrit à côté.
export default function AssistantAvatar({ height = 18, className = "" }) {
  return (
    <img src={avatar} alt="" aria-hidden="true" draggable={false} data-testid="assistant-avatar"
      style={{ height, width: "auto" }} className={`shrink-0 select-none ${className}`} />
  );
}
